// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Label = require("../common/Components/Label.bs.js");
let AgentInfo = require("../common/Agent/AgentInfo.bs.js");
let PropertyPrice = require("../common/Property/PropertyPrice.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let PropertyMlsLabel = require("./PropertyMlsLabel.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let OwnAnonymousAgentInfo = require("../client/ClientPage/OwnAnonymousAgentInfo.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyLocationForCard = require("./PropertyLocationForCard.bs.js");
let PropertySearchResultCard = require("./PropertySearchResultCard.bs.js");
let ForSalePropertyAttributes = require("../common/Property/ForSalePropertyAttributes.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let PropertySearchResultActions = require("./PropertySearchResultActions.bs.js");
let UseShouldShowPropertyDetails = require("../common/Hooks/UseShouldShowPropertyDetails.bs.js");
let PropertySearchResultTimestamp = require("./PropertySearchResultTimestamp.bs.js");
let AnonymousForSalePropertyAgentInfo = require("../client/ClientPage/AnonymousForSalePropertyAgentInfo.bs.js");
let ForSalePropertySearchResult_forSalePropertyV5_graphql = require("../../__generated__/ForSalePropertySearchResult_forSalePropertyV5_graphql.bs.js");
let ForSalePropertySearchResult_Agent_forSalePropertyV5_graphql = require("../../__generated__/ForSalePropertySearchResult_Agent_forSalePropertyV5_graphql.bs.js");
let ForSalePropertySearchResult_StatusLabel_forSalePropertyV5_graphql = require("../../__generated__/ForSalePropertySearchResult_StatusLabel_forSalePropertyV5_graphql.bs.js");

let convertFragment = ForSalePropertySearchResult_StatusLabel_forSalePropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ForSalePropertySearchResult_StatusLabel_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ForSalePropertySearchResult_StatusLabel_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ForSalePropertySearchResult_StatusLabel_forSalePropertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ForSalePropertySearchResult_StatusLabel_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ForSalePropertySearchResult$StatusLabel$WithoutErrorBoundary(props) {
  let match = RescriptRelay_Fragment.useFragment(ForSalePropertySearchResult_StatusLabel_forSalePropertyV5_graphql.node, convertFragment, props.property);
  let fragmentRefs = match.fragmentRefs;
  switch (match.status.__typename) {
    case "ExpiredProperty" :
      return JsxRuntime.jsx(Label.Neutral.make, {
        text: "Expired"
      });
    case "SoldProperty" :
      return JsxRuntime.jsx(Label.Neutral.make, {
        text: "Sold"
      });
    case "UnderContractProperty" :
      return JsxRuntime.jsx(Label.Neutral.make, {
        text: "Under Contract"
      });
    case "WithdrawnProperty" :
      return JsxRuntime.jsx(Label.Neutral.make, {
        text: "Withdrawn"
      });
    case "ActiveProperty" :
    case "__unselected" :
      return JsxRuntime.jsx(PropertyMlsLabel.make, {
        property: fragmentRefs
      });
  }
}

let WithoutErrorBoundary = {
  PropertyFragment: PropertyFragment,
  make: ForSalePropertySearchResult$StatusLabel$WithoutErrorBoundary
};

function ForSalePropertySearchResult$StatusLabel(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "status",
    children: JsxRuntime.jsx(ForSalePropertySearchResult$StatusLabel$WithoutErrorBoundary, {
      property: props.property
    })
  });
}

let StatusLabel = {
  WithoutErrorBoundary: WithoutErrorBoundary,
  make: ForSalePropertySearchResult$StatusLabel
};

let convertFragment$1 = ForSalePropertySearchResult_Agent_forSalePropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ForSalePropertySearchResult_Agent_forSalePropertyV5_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ForSalePropertySearchResult_Agent_forSalePropertyV5_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ForSalePropertySearchResult_Agent_forSalePropertyV5_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ForSalePropertySearchResult_Agent_forSalePropertyV5_graphql.node, convertFragment$1, fRef);
}

let PropertyFragment_forSalePropertyAgentVisibilityReason_decode = ForSalePropertySearchResult_Agent_forSalePropertyV5_graphql.Utils.forSalePropertyAgentVisibilityReason_decode;

let PropertyFragment_forSalePropertyAgentVisibilityReason_fromString = ForSalePropertySearchResult_Agent_forSalePropertyV5_graphql.Utils.forSalePropertyAgentVisibilityReason_fromString;

let PropertyFragment$1 = {
  forSalePropertyAgentVisibilityReason_decode: PropertyFragment_forSalePropertyAgentVisibilityReason_decode,
  forSalePropertyAgentVisibilityReason_fromString: PropertyFragment_forSalePropertyAgentVisibilityReason_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function ForSalePropertySearchResult$Agent$WithoutErrorBoundary(props) {
  let match = RescriptRelay_Fragment.useFragment(ForSalePropertySearchResult_Agent_forSalePropertyV5_graphql.node, convertFragment$1, props.property);
  let agentV2 = match.agentV2;
  switch (agentV2.__typename) {
    case "AnonymousForSalePropertyAgent" :
      return JsxRuntime.jsx(AnonymousForSalePropertyAgentInfo.make, {
        agent: agentV2.fragmentRefs,
        size: "small"
      });
    case "VisibleForSalePropertyAgent" :
      let agent = agentV2.agent;
      let tmp = agentV2.visibilityRule;
      if (tmp === "OWN_ANONYMOUS") {
        return JsxRuntime.jsx(OwnAnonymousAgentInfo.make, {
          agent: agent.fragmentRefs,
          size: "small"
        });
      }
      return JsxRuntime.jsx(AgentInfo.make, {
        agent: agent.fragmentRefs,
        size: "small"
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unexpected for sale property agent "` + agentV2._0 + `"`);
  }
}

let WithoutErrorBoundary$1 = {
  make: ForSalePropertySearchResult$Agent$WithoutErrorBoundary
};

function ForSalePropertySearchResult$Agent(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "property agent",
    children: JsxRuntime.jsx(ForSalePropertySearchResult$Agent$WithoutErrorBoundary, {
      property: props.property
    })
  });
}

let Agent = {
  PropertyFragment: PropertyFragment$1,
  WithoutErrorBoundary: WithoutErrorBoundary$1,
  make: ForSalePropertySearchResult$Agent
};

let convertFragment$2 = ForSalePropertySearchResult_forSalePropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ForSalePropertySearchResult_forSalePropertyV5_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(ForSalePropertySearchResult_forSalePropertyV5_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ForSalePropertySearchResult_forSalePropertyV5_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(ForSalePropertySearchResult_forSalePropertyV5_graphql.node, convertFragment$2, fRef);
}

let PropertyFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function ForSalePropertySearchResult(props) {
  let property = RescriptRelay_Fragment.useFragment(ForSalePropertySearchResult_forSalePropertyV5_graphql.node, convertFragment$2, props.property);
  let shouldShowPropertyDetails = UseShouldShowPropertyDetails.use(property.fragmentRefs);
  return JsxRuntime.jsx(PropertySearchResultCard.make, {
    property: property.fragmentRefs,
    label: JsxRuntime.jsx(ForSalePropertySearchResult$StatusLabel, {
      property: property.fragmentRefs
    }),
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(PropertyLocationForCard.make, {
          property: property.fragmentRefs
        }),
        JsxRuntime.jsx(PropertyPrice.make, {
          property: property.fragmentRefs,
          size: "medium"
        }),
        JsxRuntime.jsx(ForSalePropertyAttributes.make, {
          property: property.fragmentRefs,
          displayPropertyType: false
        }),
        shouldShowPropertyDetails ? JsxRuntime.jsx(ForSalePropertySearchResult$Agent, {
            property: property.fragmentRefs
          }) : null,
        JsxRuntime.jsx(PropertySearchResultTimestamp.make, {
          property: property.fragmentRefs
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(PropertySearchResultActions.make, {
            property: property.fragmentRefs
          }),
          className: "mt-auto"
        })
      ],
      className: "flex h-full flex-col gap-4"
    })
  });
}

let Card;

let make = ForSalePropertySearchResult;

exports.StatusLabel = StatusLabel;
exports.Agent = Agent;
exports.PropertyFragment = PropertyFragment$2;
exports.Card = Card;
exports.make = make;
/* Label Not a pure module */
